import React from 'react';
import Popup from "reactjs-popup";
import Invoice from './invoice';

class Cart extends React.Component {

    getCount() {
        const itemCart = this.props.cart;
        const cartKeys = Object.keys( itemCart );
        const total = cartKeys.reduce( (sum, key) => {
           return sum + Object.keys( itemCart[key].items ).length;
        }, 0);

        return total;
    }

    openCartBtn() {
        return <div className="cart">
                    <a target="_blank"> <img src="img/cart-ic0.png" />ver carrito</a>
                    <div className="cart-counter">
                        <p>{ this.getCount() }</p>
                    </div>
                </div>
    }

    render() {
        return <Popup trigger={ () => this.openCartBtn() } modal closeOnDocumentClick>
                {close => (
                    <Invoice
                        close={close}
                        cart={this.props.cart}
                        count={ this.getCount() }
                        deleteFromCart={this.props.deleteFromCart}
                        reset={this.props.reset}
                        />
                )}
            </Popup>
    }

}

export default Cart;